/**
 * Ilustración de pizza para productos sin foto (sustituye el texto «Sin imagen»).
 * SVG inline: no depende de archivos externos ni de la API.
 */
export default function PizzaPlaceholder({ className = '', label = '' }) {
  return (
    <div
      className={`relative w-full overflow-hidden bg-gradient-to-br from-orange-100 via-amber-50 to-red-100 flex items-center justify-center ${className}`}
      role="img"
      aria-label={label ? `Ilustración de pizza: ${label}` : 'Ilustración de pizza'}
    >
      <svg
        viewBox="0 0 200 200"
        className="h-[78%] w-auto drop-shadow-md"
        aria-hidden="true"
        focusable="false"
      >
        {/* tabla de madera */}
        <circle cx="100" cy="100" r="96" fill="#C98B4E" />
        <circle cx="100" cy="100" r="90" fill="#D9A066" />
        {/* orilla */}
        <circle cx="100" cy="100" r="80" fill="#E8B26A" />
        <circle cx="100" cy="100" r="80" fill="none" stroke="#C98545" strokeWidth="3" strokeDasharray="2 9" />
        {/* salsa y queso */}
        <circle cx="100" cy="100" r="69" fill="#D9472B" />
        <path
          d="M100 36c18 2 30 8 40 17 9 9 7 18 18 26 7 6 6 18 1 27-4 8-12 10-13 20-1 11-10 18-21 21-10 3-17-3-27 0-10 3-19 8-29 2-9-6-8-15-15-22-7-7-17-10-17-22 0-11 9-16 11-26 2-11-2-20 7-28 9-9 20-8 30-12 5-2 10-4 15-3z"
          fill="#FCD26B"
        />
        {/* cortes */}
        <g stroke="#E8B26A" strokeWidth="2.5" opacity="0.9">
          <line x1="100" y1="31" x2="100" y2="169" />
          <line x1="31" y1="100" x2="169" y2="100" />
          <line x1="51" y1="51" x2="149" y2="149" />
          <line x1="149" y1="51" x2="51" y2="149" />
        </g>
        {/* peperoni */}
        <g fill="#B3261E">
          <circle cx="78" cy="66" r="10" />
          <circle cx="128" cy="74" r="10" />
          <circle cx="66" cy="114" r="10" />
          <circle cx="118" cy="128" r="10" />
          <circle cx="100" cy="96" r="9" />
          <circle cx="140" cy="112" r="8" />
          <circle cx="88" cy="140" r="8" />
        </g>
        <g fill="#8E1B15" opacity="0.45">
          <circle cx="75" cy="63" r="2" />
          <circle cx="131" cy="71" r="2" />
          <circle cx="63" cy="111" r="2" />
          <circle cx="121" cy="125" r="2" />
        </g>
        {/* albahaca */}
        <g fill="#3E8E41">
          <ellipse cx="112" cy="58" rx="7" ry="3.5" transform="rotate(-30 112 58)" />
          <ellipse cx="56" cy="88" rx="7" ry="3.5" transform="rotate(40 56 88)" />
          <ellipse cx="146" cy="138" rx="7" ry="3.5" transform="rotate(-15 146 138)" />
          <ellipse cx="96" cy="118" rx="6" ry="3" transform="rotate(60 96 118)" />
        </g>
        {/* aceitunas */}
        <g fill="none" stroke="#2B2B2B" strokeWidth="3">
          <circle cx="144" cy="92" r="4" />
          <circle cx="82" cy="92" r="4" />
          <circle cx="106" cy="148" r="4" />
        </g>
      </svg>
    </div>
  );
}
